// src/i18n/tgbot.ts —— 06 admin-console C-15 文案包（Telegram Bot 配置；经 PAGES_TGBOT.i18n 挂入 table 域字典，TD-849）。
// 06 给出文案的键逐字取 06（含 SP8 回写 W-7 定稿英文）；06 未给键名或文案的新增键以 tgb 前缀定义，标「本计划定稿」（T14 回写 06 C-15）。
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_TGBOT: I18nPack = {
  zh: {
    // ---- 06 C-15 已定名键 ----
    kBotUsers: '全部 Bot 注册来源用户', // [改写 key]
    kBotUsersSub: '各 Bot 注册来源用户合计', // [改写 key]
    cBotUsers: '注册来源用户', // [改写 key]
    toastTgMe: 'getMe 200 · {username} 在线', // [改写 key]：以实际 username 渲染（06 C-15 Tab1）
    botProxyTip: '一期代理自有 Bot 的 Token 由平台在此代录（代理端无 Bot 管理页）。',
    regenSecretTitle: '重新生成 secret_token',
    regenSecretText: '将生成新的 secret 并立即以新值调用 setWebhook，旧 secret 即刻失效。',
    toastSecretRegen: 'secret_token 已重新生成并完成 setWebhook',
    cMiniLabel: '菜单按钮文案',
    cMiniLabelEn: '菜单按钮文案（EN）',
    errKbDup: '键盘按钮文案重复',
    errMinTopup: '单笔最小不得低于系统最小充币 {minDeposit} USDT',
    // ---- 本计划定稿（06 未给键名） ----
    tgbDescEn: '描述（EN）',
    tgbLabelEn: '按钮文案（EN）',
    tgbWelcomeEn: '欢迎语 /start（EN）',
    tgbAgentTextEn: '全民代理文案（EN）',
    tgbRegen: '重新生成',
    tgbRegenPolling: '轮询模式不使用 secret_token',
    tgbCopy: '复制',
    tgbHookAgain: '配置已保存并下发到 Bot；allowed_updates 已变更，请再点一次 setWebhook 使其生效',
    tgbHookFail: 'Bot 已保存，但 setWebhook 失败：{error}',
    tgbSteps: '下发结果：{steps}',
    tgbErrRateLimited: 'Telegram 限速，请 {n} 秒后再试（连续点击会延长限速）',
    tgbErrBotDisabled: '该 Bot 已停用，请先在 Bot 列表中启用',
    tgbErrLastPlatform: '这是最后一个启用中的平台 Bot，不能删除',
    tgbErrNotWebhook: '仅 Webhook 模式可用',
    tgbErrToken: 'Bot Token 格式不正确',
    tgbErrBotId: 'Bot Telegram ID 须为数字，且等于 Token 冒号前的数字',
    tgbErrUsername: '用户名须以 @ 开头',
    tgbErrAgent: '归属为代理商时须选择代理商',
    tgbAgentCap: '（仅列出前 50 个代理）',
    tgbErrNoPublicBase: '未配置公网回调地址（HOOK_PUBLIC_BASE_URL），无法设置 Webhook，请联系运维配置',
    tgbPrimary: '主 Bot',
    tgbPrimaryScope: '官网按钮和链接、代理端与 H5 展示的平台 Bot、后台告警的 Telegram 推送均使用主 Bot',
    tgbSetPrimary: '设为主 Bot',
    tgbPrimaryTitle: '设为主 Bot',
    tgbPrimaryText: '设为主 Bot 后，官网的 Telegram 按钮和链接、代理端与 H5 展示的平台 Bot、后台告警的 Telegram 推送将切换到该 Bot，原主 Bot 改为普通平台 Bot。用户的消息通知仍由各自绑定的 Bot 发送，不受影响。',
    tgbPrimaryDone: '已将 {username} 设为主 Bot',
    tgbErrPrimary: '这是主 Bot，不能停用、改为代理商 Bot 或删除，请先把其他 Bot 设为主 Bot',
    tgbErrPrimaryTarget: '只有启用中的平台 Bot 可以设为主 Bot',
  },
  en: {
    kBotUsers: 'Sign-ups across bots', // 本计划定稿（SP8 W-7）
    kBotUsersSub: 'Sum of per-bot sign-ups', // 本计划定稿（SP8 W-7）
    cBotUsers: 'Sign-ups via bot',
    toastTgMe: 'getMe 200 · {username} online',
    botProxyTip: "Phase 1: an agent's own bot token is entered here by the platform (the agent portal has no bot management).", // 本计划定稿（SP8 W-7）
    regenSecretTitle: 'Regenerate secret_token', // 本计划定稿（SP8 W-7）
    regenSecretText: 'A new secret will be generated and setWebhook called with it immediately; the old secret stops working at once.', // 本计划定稿（SP8 W-7）
    toastSecretRegen: 'secret_token regenerated and webhook reset',
    cMiniLabel: 'Menu button label',
    cMiniLabelEn: 'Menu button label (EN)',
    errKbDup: 'Duplicate keyboard label',
    errMinTopup: 'Min per order must not be below the system minimum deposit {minDeposit} USDT', // 本计划定稿（SP8 W-7）
    tgbDescEn: 'Description (EN)',
    tgbLabelEn: 'Button label (EN)',
    tgbWelcomeEn: 'Welcome /start (EN)',
    tgbAgentTextEn: 'Referral text (EN)',
    tgbRegen: 'Regenerate',
    tgbRegenPolling: 'Polling mode does not use secret_token',
    tgbCopy: 'Copy',
    tgbHookAgain: 'Saved and pushed to the bot. allowed_updates changed: click setWebhook again to apply it',
    tgbHookFail: 'Bot saved, but setWebhook failed: {error}',
    tgbSteps: 'Push result: {steps}',
    tgbErrRateLimited: 'Telegram rate limit, retry in {n}s (repeated clicks extend the limit)',
    tgbErrBotDisabled: 'This bot is disabled. Enable it in the bot list first',
    tgbErrLastPlatform: 'This is the last active platform bot and cannot be deleted',
    tgbErrNotWebhook: 'Available in webhook mode only',
    tgbErrToken: 'Invalid bot token format',
    tgbErrBotId: 'Bot Telegram ID must be numeric and equal the number before the colon in the token',
    tgbErrUsername: 'Username must start with @',
    tgbErrAgent: 'Select an agent when the owner is an agent',
    tgbAgentCap: '(first 50 agents only)',
    tgbErrNoPublicBase: 'Public callback base URL (HOOK_PUBLIC_BASE_URL) is not configured, so the webhook cannot be set. Ask ops to configure it',
    tgbPrimary: 'Primary',
    tgbPrimaryScope: 'Used for the website button and links, the platform bot shown in the agent portal and H5, and Telegram delivery of admin alerts',
    tgbSetPrimary: 'Set as primary',
    tgbPrimaryTitle: 'Set as primary bot',
    tgbPrimaryText: "The website's Telegram button and links, the platform bot shown in the agent portal and H5, and Telegram delivery of admin alerts will switch to this bot. The current primary bot becomes a regular platform bot. User notifications still go through each user's own bot.",
    tgbPrimaryDone: '{username} is now the primary bot',
    tgbErrPrimary: 'This is the primary bot. It cannot be disabled, assigned to an agent or deleted. Set another bot as primary first',
    tgbErrPrimaryTarget: 'Only an active platform bot can be set as primary',
  },
};

// TD-805：覆盖原型字典的键（06 [改写 key]）
export const REWRITES_TGBOT: readonly string[] = ['kBotUsers', 'kBotUsersSub', 'cBotUsers', 'toastTgMe'];
